<template>
   <div class="Features-title">
      <PageHeader :title="$t('pages.features.info.title')"
                  :desc="$t('pages.features.info.text')">
          <DownloadButton>{{$t('pages.features.info.downloadButtonDesc')}}</DownloadButton>
      </PageHeader>

      <PageFrameContainer>
         <PlayerFeature/>
         <AutomaticModeFeature/>
         <StudioFeature/>
         <MapperFeature/>
         <UrlEditorFeature/>
         <ClockServerFeature/>
         <br>
      </PageFrameContainer>
   </div>
</template>

<script>
    import PlayerFeature from "./parts/PlayerFeature";
    import AutomaticModeFeature from "./parts/AutomaticModeFeature";


    import PageFrameContainer from "../../components/PageFrameContainer";
    import StudioFeature from "./parts/StudioFeature";
    import MapperFeature from "./parts/MapperFeature";
    import UrlEditorFeature from "./parts/UrlEditorFeature";
    import ClockServerFeature from "./parts/ClockServerFeature";
    import PageHeader from "../../components/PageHeader";
    import DownloadButton from "../../components/DownloadButton";

    export default {
        name: "FeaturesPage",
        components: {
            DownloadButton,
            PageHeader,
            ClockServerFeature,
            UrlEditorFeature,
            MapperFeature,
            StudioFeature,
            PlayerFeature,
            AutomaticModeFeature,
            PageFrameContainer
        }
    }
</script>

<style scoped lang="scss">
   @import "../../theme/theme";
   .Features-title {
      text-align:justify;
   }

</style>